<script setup lang="ts">
import Home from "@/components/Home.vue";
import Page from "@/components/Page.vue";
import Swoosh from "@/components/identity/Swoosh.vue";
import BeforeAfter from "@/components/identity/BeforeAfter.vue";
import Quote from "@/components/identity/Quote.vue";
import PoslednikVideo from "@/components/identity/PoslednikVideo.vue";
import Slogan from "@/components/identity/Slogan.vue";
import ContentMaxWidth from "@/components/ContentMaxWidth.vue";
import Button from "@/components/Button.vue";
</script>

<template>
    <Page>
        <ContentMaxWidth :width="800">
            <Slogan class="mb-8" />

            <Swoosh />

            <PoslednikVideo />

            <Swoosh />

            <h3 class="text-xl font-bold mb-4">
                Nam placerat euismod dictum. Maecenas scelerisque nisi ac ipsum
                vehicula hendrerit
            </h3>

            <p class="mb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam eu
                ante dolor. Suspendisse vel ante nibh. Curabitur sagittis
                elementum orci, ut condimentum justo condimentum ut.
            </p>

            <p>
                Praesent accumsan, mi sed consectetur cursus, turpis massa
                congue magna.
            </p>

            <div class="flex flex-col gap-6 mt-8 items-center mb-8">
                <Button> Unfallinstand- setzung</Button>
                <Button> Camper & Caravan</Button>
                <Button> Bus & LKW</Button>
                <Button> Sonderlackierung</Button>
            </div>
        </ContentMaxWidth>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 justify-center">
            <div>
                <BeforeAfter
                    before="images/before-after/1/Bild4.jpg"
                    after="images/before-after/1/Bild61.jpg"
                />
            </div>

            <div>
                <BeforeAfter
                    before="images/before-after/2/Bild9.jpg"
                    after="images/before-after/2/Bild71.jpg"
                />
            </div>
        </div>

        <div>
            <ContentMaxWidth :width="800">
                <p class="mb-8">
                    Cras quis vehicula ipsum, et suscipit odio. Pellentesque sit
                    amet ex vel orci venenatis ornare. Donec vel quam dictum,
                    tincidunt ante in, feugiat leo. Mauris quis lectus
                    tincidunt, egestas diam sit amet, mollis nunc. Etiam
                    efficitur erat justo, id lacinia est tincidunt sollicitudin.
                    Aenean lobortis tincidunt suscipit. Vestibulum ante ipsum
                    primis in
                </p>

                <h3 class="text-xl font-bold mb-4">
                    Donec eu eros quis metus porta tincidunt
                </h3>

                <p>
                    Quisque et molestie nulla. Vestibulum bibendum, libero ut
                    ornare pulvinar, ante massa congue lorem, non ornare dui
                    enim id elit. Fusce maximus feugiat sodales. Donec eu eros
                    quis metus porta tincidunt. Phasellus eu leo non magna
                    blandit tempor vel nec dolor. Integer congue erat ac justo
                    finibus fermentum. In dolor augue, imperdiet nec urna ut,
                    convallis sollicitudin tellus. Cras sed ullamcorper erat.
                </p>

                <Quote> Haben wir dein Interesse geweckt?</Quote>

                <img class="w-full" src="images/Bild66.jpg" alt="" />

                <Swoosh />
            </ContentMaxWidth>
        </div>
    </Page>
</template>
